import { useTheme } from '@mui/material';
import { FieldRenderBlockProp } from '../..';
import ListAvatarBlock from '../../_utils/list-avatar-block';

export default function CalendlyBlockRenderer(props: FieldRenderBlockProp) {
  const theme = useTheme();

  if (!props.data?.calendly) return <></>;

  return (
    <ListAvatarBlock
      title={props.data.calendly?.title}
      value={props.data.calendly?.value}
      e={props}
    />
  );
}
